import AuthService from './authService';
import FreelancerUserIgnoredSurveyItem from '../Domain/FreelancerUserIgnoredSurveyItem';

export default class FreelancerUserIgnoredSurveyService {
  static async AddIgnoredSurvey(editedItem) {
    const url = `api/FreelancerUserIgnoredSurvey/AddIgnoredSurveyAsync`;

    return AuthService.getInstance().CallBackendFunctionPost(url, editedItem);
  }

  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    return AuthService.getInstance().CallBackendFunction(
      `/api/FreelancerUserIgnoredSurvey/GetListBySearching?searchParams=${JSON.stringify(
        searchParams
      )}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new FreelancerUserIgnoredSurveyItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ChangeIsActiveStatus(item) {
    return AuthService.getInstance().CallBackendFunctionPut(
      `/api/FreelancerUserIgnoredSurvey/ChangeIsActiveStatusAsync/${item.FreelancerUserIgnoreSurveyId}`
    );
  }
}
